import { call, put, takeLatest, all } from 'redux-saga/effects';
import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import * as Actions from '../../actions';

function* createOperation(action) {
	let data = action.payload;

	try {
		const response = yield call(() => axios.post('/api/v1/operations', data));
        yield put(Actions.createOperationSuccess(response.data));
        
        yield put(Actions.fetchResourceOperations({ resourceId: data.resourceId }));

		yield put(
			showMessage({
				message: 'Operation Created',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(
			showMessage({
				message: `Unable to Create Operation: 
                      ${error && error.response && error.response.data ? error.response.data.split('\n')[0] : ''}`,
				variant: 'error'
			})
		);
		yield put(Actions.createOperationFailure());
	}
}

function* updateOperation(action) {
	const data = action.payload;

	try {
		const response = yield call(() => axios.put('/api/v1/operations', data));
		yield put(Actions.updateOperationSuccess(response.data));

		yield put(Actions.fetchResourceOperations({ resourceId: data.resourceId }));

		yield put(
			showMessage({
				message: 'Operation Updated',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(
			showMessage({
				message: `Unable to Update Operation: 
                      ${error && error.response && error.response.data ? error.response.data.split('\n')[0] : ''}`,
				variant: 'error'
			})
		);
		yield put(Actions.updateOperationFailure());
	}
}

function* deleteOperation(action) {
	const data = action.payload;

	try {
		const response = yield call(() => axios.delete('/api/v1/operations', {data: data}));
        yield put(Actions.deleteOperationSuccess(response.data));
        
        yield put(Actions.fetchResourceOperations({ resourceId: data.resourceId }));

		yield put(
			showMessage({
				message: 'Operation Deleted',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(
			showMessage({
				message: 'Unable to Delete Operation',
				variant: 'error'
			})
		);
		yield put(Actions.deleteOperationFailure());
	}
}

function* watchOperation() {
	yield all([
		takeLatest(Actions.createOperation, createOperation),
		takeLatest(Actions.updateOperation, updateOperation),
		takeLatest(Actions.deleteOperation, deleteOperation),
	]);
}

export default watchOperation;
